// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export const repositoriesAutocompleteConstants = {
  placeholder: 'Search Repositories',
  notFound: 'No repositories found.',
};
